export default __webpack_public_path__ + "static/media/iPhone 8 - 2.01d1d5b5.png";